<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="0.8" class="background-circular" src="/assets/img/background-circular.svg" alt="Background Circular" />
<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.5" class="background-circular" src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />


<app-navbar></app-navbar>


<!-- Help Center -->
<div *ngIf="!isLoading" class="help-center">
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.lt-lg="90%">
            <h1>{{ section.title }}</h1>

            <!--<div class="search">
                <mat-form-field appearance="fill">
                    <span matPrefix class="jam jam-search" aria-label="Email Icon"></span>
                    <input type="text" matInput [matAutocomplete]="auto" placeholder="Haz una pregunta...">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <button mat-button>Buscar</button>
            </div>-->

            <p>{{ section.data.main_caption }}</p>
        </div>
    </div>
</div>


<!-- Cards Sections Guide -->
<div *ngIf="!isLoading" class="cards" fxLayoutAlign="center space-between" fxHide.xs>
    <div fxLayout="row" fxLayout.sm="row wrap" fxFlex="1200px" fxFlex.lt-lg="90%" fxLayoutGap="30px" fxFlexOffset.sm="30px">

        <div *ngFor="let box of boxes" fxFlex="25%" fxFlex.sm="0 1 calc(50% - 30px)">
            <button mat-button class="item" [ngClass]="{'active': boxActive == box.id}" (click)="clickBox(box)">
                <span class="jam jam-flag"></span>
                <h4>{{ box.title }}</h4>
            </button>
        </div>

    </div>
</div>


<!-- Carousel Cards Sections -->
<div *ngIf="!isLoading" class="carousel-cards-sections" fxHide fxShow.xs>
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="100%">

            <!-- <mat-carousel interval="99999999999999999" autoplay="false" [hideIndicators]="false" [slides]="boxes.length" maintainAspectRatio="true" slideHeight="500px">
                <mat-carousel-slide *ngFor="let box of boxes">
                    <button mat-button class="item" [ngClass]="{'active': boxActive == box.id}" (click)="clickBox(box)">
                        <span class="jam jam-flag"></span>
                        <h4>{{ box.title }}</h4>
                    </button>
                </mat-carousel-slide>
            </mat-carousel> -->

            <drag-scroll #cardSections drag-scroll-y-disabled="true" scrollbar-hidden="true">
                <div *ngFor="let box of boxes" drag-scroll-item>
                    <button mat-button class="item" [ngClass]="{'active': boxActive == box.id}" (click)="clickBox(box)">
                        <span class="jam jam-flag"></span>
                        <h4>{{ box.title }}</h4>
                    </button>
                </div>
            </drag-scroll>

        </div>
    </div>
</div>


<!-- Content Cards Sections -->
<div *ngIf="!isLoading" class="cards-content">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center start">
        <div fxFlex="1000px" fxFlex.xs="100%" fxFlex.lt-lg="90%">
            <!-- Card Content One -->
            <ng-container *ngFor="let box of boxes">
                <div [@cardsAnimation] *ngIf="boxActive == box.id">
                    <div class="title">
                        <h2>{{ box.title }}</h2>
                        <p>{{ box.caption }}</p>
                    </div>

                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let ques of box.questions">
                            <mat-expansion-panel-header>
                                {{ ques.title }}
                            </mat-expansion-panel-header>

                            <p [innerHTML]="ques.caption | nl2br"></p>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </ng-container>

        </div>
    </div>
</div>


<!-- ¿Todavia tienes preguntas? -->
<div *ngIf="!isLoading" class="more-questions">
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="800px" fxFlex.lt-lg="90%">
            <h2>¿Todavía tenés preguntas?</h2>
            <p>Escribinos a cualquiera de nuestros canales de comunicación, WhatsApp o E-Mail, y responderemos tu consulta a la brevedad.</p>
        </div>
    </div>
    <div class="elements" fxLayoutAlign="center start">
        <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1000px" fxFlex.lt-lg="90%" fxLayoutGap="80px" fxLayoutGap.lt-md="0px">
            <div fxFlex="50%">
                <div class="element item-phone">
                    <span class="jam jam-viber"></span>
                    <h3> <a href="https://wa.me/543462583388">3462-583388</a></h3>
                    <!-- <p><small>Estamos felices de poder ayudarte.</small></p> -->
                </div>

                <div class="element item-email">
                    <span class="jam jam-messages-alt-f"></span>
                    <h3>plazahogar@amvt.com.ar</h3>
                    <!-- <p><small>La mejor forma de conseguir rápidamente una respuesta.</small></p> -->
                </div>
            </div>
            <div fxFlex="50%">
                <div class="form-container">
                    <h3>Dejanos un mensaje</h3>
                    <mat-form-field appearance="fill">
                        <mat-label>Nombre completo</mat-label>
                        <input [(ngModel)]="contactName" type="text" matInput placeholder="" required />
                        <span matSuffix class="jam jam-user-circle"></span>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Correo electrónico</mat-label>
                        <input [(ngModel)]="contactEmail" type="email" matInput placeholder="" required />
                        <span matSuffix class="jam jam-messages-alt"></span>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Mensaje</mat-label>
                        <textarea [(ngModel)]="contactMessage" matInput rows="4" required minlength="10" maxlength="1500"></textarea>
                    </mat-form-field>
                    <re-captcha style="display: inline-block;"
                    name="captcha"
                    (resolved)="resolved($event)"
                    required
                    siteKey="6LeLX9AZAAAAAHAgXE8Z1R0alnrbqy3olDXbYEws">
                    </re-captcha>

                   <button mat-button type="submit" (click)="onClickContact()" [disabled]="!captchaResolved">ENVIAR MENSAJE</button>
                  </div>
            </div>
        </div>
    </div>
</div>


<app-footer></app-footer>
